import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { selectEventGroupFilters, setAllEventGroupFilters, setOnlyEventGroupFilter, toggleEventGroupFilter } from 'src/slices/gameEvents.slice';

const EVENT_FILTER_GROUPS = [
    { key: 'sdk', label: 'SDK' },
    { key: 'gameplay', label: 'Gameplay' },
    { key: 'ads', label: 'Ad' },
    { key: 'measure', label: 'Measure' },
    { key: 'leaderboard', label: 'Leaderboard' },
];

const PillRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
`;

const Pill = styled.button`
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 700;
    border-radius: 999px;
    border: none;
    background: ${({ $active }) => ($active ? 'var(--poki-blue)' : 'var(--surface-muted)')};
    color: ${({ $active }) => ($active ? '#fff' : 'var(--text-secondary)')};
    transition: background-color 120ms, color 120ms, border-color 120ms;
    cursor: pointer;

    &:hover {
        color: ${({ $active }) => ($active ? '#fff' : 'var(--text-primary)')};
    }
`;

export default function EventLogFilterPills() {
    const dispatch = useDispatch();
    const eventGroupFilters = useSelector(selectEventGroupFilters);

    const allMode = Object.values(eventGroupFilters).every(Boolean);

    const handleClickAll = () => {
        if (!allMode) {
            dispatch(setAllEventGroupFilters(true));
        }
    };

    const handleClickGroup = (groupKey) => {
        if (allMode) {
            dispatch(setOnlyEventGroupFilter(groupKey));
            return;
        }

        const nextFilters = { ...eventGroupFilters, [groupKey]: !eventGroupFilters[groupKey] };
        const noneActive = Object.values(nextFilters).every((v) => !v);

        if (noneActive) {
            dispatch(setAllEventGroupFilters(true));
        } else {
            dispatch(toggleEventGroupFilter(groupKey));
        }
    };

    return (
        <PillRow>
            <Pill type="button" $active={allMode} onClick={handleClickAll}>
                All
            </Pill>
            {EVENT_FILTER_GROUPS.map(({ key, label }) => (
                <Pill
                    key={key}
                    type="button"
                    $active={!allMode && !!eventGroupFilters[key]}
                    onClick={() => handleClickGroup(key)}
                >
                    {label}
                </Pill>
            ))}
        </PillRow>
    );
}
